import { data } from './data';
import { areCartItemsDuplicates } from '../../utils/areCartItemsDuplicates';
const getDuplicateLineNumbers = () => {
    const duplicateLineNumbers = [];
    data.items.forEach((mainItem, mainLineNumber) => {
        if (duplicateLineNumbers.includes(mainLineNumber))
            return;
        if (mainItem.sku !== 'Custom_TILE' && mainItem.quantity > 1) {
            duplicateLineNumbers.push(mainLineNumber);
            return;
        }
        data.items.forEach((item, lineNumber) => {
            if (areCartItemsDuplicates(mainItem, item)) {
                duplicateLineNumbers.push(mainLineNumber);
                !duplicateLineNumbers.includes(lineNumber) && duplicateLineNumbers.push(lineNumber);
            }
        });
    });
    return duplicateLineNumbers;
};
const getDuplicatesForItem = (item) => {
    const duplicateLineNumbers = [];
    data.items.forEach((dataItem, lineNumber) => {
        if (areCartItemsDuplicates(item, dataItem)) {
            duplicateLineNumbers.push(lineNumber);
        }
    });
    return duplicateLineNumbers;
};
export const duplicates = {
    getLineNumbers: getDuplicateLineNumbers,
    getForItem: getDuplicatesForItem
};
